import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Eye, EyeOff } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import GoogleSignIn from "../../components/auth/GoogleSignIn";
import BackgroundWrapper from "../../components/common/BackgroundWrapper";
import "./Auth.css";

const Register = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { register: registerUser, loading } = useAuth();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    watch,
  } = useForm();

  const password = watch("password");

  const onSubmit = async (data) => {
    const result = await registerUser({
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      password: data.password,
    });

    if (result.success) {
      navigate("/");
    } else {
      setError("root", { message: result.message });
    }
  };

  return (
    <BackgroundWrapper background="/auth-grid.png">
      <div className="auth-wrapper">
        <div className="auth-card">
          <h2 className="auth-title-small">Create Account</h2>
          <p className="auth-subtext">Join the Lilyth community ✨</p>

          {errors.root && (
            <div className="error-message">{errors.root.message}</div>
          )}

          {/* Google Sign-Up */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <GoogleSignIn mode="register">
              <button className="google-circle">
                <b>G</b>
              </button>
            </GoogleSignIn>
          </div>

          <p style={{ textAlign: "center" }}>or</p>

          <form onSubmit={handleSubmit(onSubmit)}>
            <input
              className="auth-input"
              placeholder="First Name"
              {...register("firstName", { required: "First name required" })}
            />

            <input
              className="auth-input"
              placeholder="Last Name"
              {...register("lastName", { required: "Last name required" })}
            />

            <input
              className="auth-input"
              placeholder="Email"
              type="email"
              {...register("email", { required: "Email required" })}
            />

            <div className="password-wrapper">
              <input
                className="auth-input"
                placeholder="Password"
                type={showPassword ? "text" : "password"}
                {...register("password", {
                  required: "Password required",
                  minLength: { value: 6, message: "Min 6 characters" },
                })}
              />
              <button
                className="password-toggle"
                type="button"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>

            <div className="password-wrapper">
              <input
                className="auth-input"
                placeholder="Confirm Password"
                type={showConfirmPassword ? "text" : "password"}
                {...register("confirmPassword", {
                  required: "Confirm password",
                  validate: (value) =>
                    value === password || "Passwords do not match",
                })}
              />
              <button
                className="password-toggle"
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>

            <button className="auth-submit" disabled={loading}>
              Create Account
            </button>
          </form>

          <div className="auth-footer">
            Already have an account?{" "}
            <Link to="/login" className="auth-link">
              Sign In
            </Link>
          </div>
        </div>
      </div>
    </BackgroundWrapper>
  );
};

export default Register;
